import apiService from "./api";

const warehouseService = {
  addDocumentTransaction(payload) {
    return apiService.post("/warehouse-transaction/store-more", payload);
  },
  createOffer(payload) {
    return apiService.post("/warehouse/offer", payload);
  },
  updateOffer(id, payload) {
    return apiService.put(`/warehouse/offer/${id}`, payload);
  },
  getOffers(params) {
    return apiService.get("/warehouse/offer", params);
  },
  editDocumentTransaction(documentId, payload) {
    return apiService.put(`/warehouse-transaction/${documentId}/edit-more`, payload);
  },
  lockDocument(documentId) {
    return apiService.patch(`/warehouse-new/documents/${documentId}/lock`);
  },
  // Add create warehouse
  createWarehouse(payload) {
    return apiService.post("/warehouse-new", payload);
  },
  // Add update warehouse
  updateWarehouse(id, payload) {
    return apiService.put(`/warehouse-new/${id}`, payload);
  },
  getWarehouseStocktaking(warehouseId, payload) {
    return apiService.get(`/warehouse/${warehouseId}/list`, payload);
  },
  createWarehouseStocktaking(warehouseId, payload) {
    return apiService.post(`/warehouse/list`, payload);
  },
  updateWarehouseStocktaking(warehouseId, id, payload) {
    return apiService.put(`/warehouse/${warehouseId}/list/${id}`, payload);
  },
  deleteWarehouseStocktaking(warehouseId, id) {
    return apiService.delete(`/warehouse/${warehouseId}/list/${id}`);
  },
  getWarehouseStocktakingItems(stocktakingId) {
    return apiService.get(`/warehouse/list/${stocktakingId}/items`);
  },
  getStocktakingDetails(listId) {
    return apiService.get(`/warehouse/list/${listId}`);
  },
  saveStocktakingGrocery(payload) {
    return apiService.post(`/warehouse/list-groceries`, payload);
  },
  completeList(payload) {
    return apiService.post(`/warehouse/list-correction`, payload);
  },

  // Add update warehouse
  removeWarehouse(id) {
    return apiService.delete(`/warehouse-new/${id}`);
  },
  createSupplier(payload) {
    return apiService.post("/suppliers", payload);
  },
  updateSupplier(id, payload) {
    return apiService.put(`/suppliers/${id}`, payload);
  },
  deleteSupplier(id) {
    return apiService.delete(`/suppliers/${id}`);
  },
  getTransactions(payload) {
    return apiService.get("/warehouse-transaction", payload);
  },
  getSuppliers(payload) {
    return apiService.get("/suppliers", payload);
  },
  getInventory() {
    return apiService.get("/inventory");
  },
  getWarehouses() {
    return apiService.get("/warehouse-new");
  },
  // Add warehouse report fetch
  getWarehouseReport(showType, restaurantId, params) {
    return apiService.get(
      `/reports/warehouse-new/${showType}/restaurant/${restaurantId}`,
      params
    );
  },
  getWarehouseReportV2(showType, restaurantId, params) {
    return apiService.get(
      `/reports/warehouse-new-v2/${showType}/restaurant/${restaurantId}`,
      params
    );
  },
  // Add warehouse documents fetch
  getWarehouseDocuments(params) {
    return apiService.get("/warehouse-new/documents", params);
  },
  getSupplierDocuments() {
    return apiService.get("/warehouse-new/documents/supplier");
  },
  getSupplierUsers(supplierId) {
    return apiService.get(`/suppliers/${supplierId}/users`);
  },
  getSupplierRestaurants(supplierId) {
    return apiService.get(`/suppliers/${supplierId}/restaurants`);
  },
  attachRestaurantsToSupplier(supplierId, restaurantIds) {
    return apiService.post(`/suppliers/${supplierId}/attach-restaurants`, { restaurant_ids: restaurantIds });
  },
  addSupplierUser(supplierId, payload) {
    return apiService.post(`/suppliers/${supplierId}/users`, payload);
  },
  updateSupplierUser(supplierId, userId, payload) {
    return apiService.put(`/suppliers/${supplierId}/users/${userId}`, payload);
  },
  removeSupplierUser(supplierId, userId) {
    return apiService.delete(`/suppliers/${supplierId}/users/${userId}`);
  },
  // Add warehouse users fetch
  getWarehouseUsers(restaurantId) {
    return apiService.get(`/restaurants/${restaurantId}/users`);
  },
  // Add patch warehouse
  patchWarehouse(id, payload) {
    return apiService.patch(`/warehouse-new/${id}`, payload);
  },
  // Get warehouse daily report (old version)
  getDailyWarehouseReport(restaurantId, params) {
    return apiService.get(`/reports/warehouse/daily/restaurant/${restaurantId}`, params);
  },
  getDailyGroupWarehouseReport(restaurantId, params) {
    return apiService.get(`/reports/warehouse/daily-group/restaurant/${restaurantId}`, params);
  },
  // Get warehouse users (old endpoint)
  getWarehouseUsersOld(data) {
    return apiService.post('/warehouse/get-warehouse-users', data);
  },
  // Save groceries to warehouse
  saveGroceriesWarehouse(data) {
    return apiService.post('/warehouse/save-groceries-warehouse', data);
  },
  // Update warehouse item (old version)
  updateWarehouseItem(data) {
    return apiService.post('/warehouse', data);
  },
  getStocktakings(params) {
    return apiService.get('/stocktaking', params);
  },
  getGroceriesWithWarehouse() {
    return apiService.get('/groceries', { warehouse: true });
  },
  getWarehouseStatus(params) {
    return apiService.get('/inventory/status', params);
  },
};

export default warehouseService;
